// extracted by mini-css-extract-plugin
export var hidden = "_oi-1";
export var visible = "_oi-0";